/**
 * Description:工作状态Api
 * Created by wxy on 2018/10/29
 */
import request from '@/utils/request'
const baseUrl = '/personal'

/**
 * 工作状态管理
 */
const workStatusList = () => request({
  url: `${baseUrl}/workstatus/getWorkstatus`,
  method: 'GET'
})

const addWorkStatus = (data) => request({
  url: `${baseUrl}/workstatus/setWorkstatus`,
  method: 'POST',
  data
})

const updateWorkStatus = (data) => request({
  url: `${baseUrl}/workstatus/updateWorkstatus`,
  method: 'POST',
  data
})

const removeWorkStatus = (data) => request({
  url: `${baseUrl}/workstatus/deleteWorkstatus`,
  method: 'POST',
  data
})

/**
 * 修改、获取工作状态
 */
const employeeWorkStatus = (data) => request({
  url: `${baseUrl}/workstatus/listEmpworkstatus`,
  method: 'POST',
  data
})

const updateEmpWorkstatus = (data) => request({
  url: `${baseUrl}/workstatus/updateEmpWorkstatus`,
  method: 'POST',
  data
})

const delHistoryWorkstatus = (data) => request({
  url: `${baseUrl}/workstatus/delHistoryWorkstatus`,
  method: 'GET',
  data
})

export {
  workStatusList,
  addWorkStatus,
  updateWorkStatus,
  removeWorkStatus,
  employeeWorkStatus,
  updateEmpWorkstatus,
  delHistoryWorkstatus
}



// WEBPACK FOOTER //
// ./src/api/systemManagement/workStatus.js